import baseAPI from '@/api/base';
import {
  GetYurtzeitenDesign_N,
  SaveYurtzeitenDesign_N,
} from '@/dtos/yurtzeiten_design_N.dto';
import {
  GET_YURTZEITEN_DESIGN_N_URL,
  SAVE_YURTZEITEN_DESIGN_N_URL,
  UPLOAD_YURTZEITEN_DESIGN_IMAGE_N_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class YurtzeitenDesign_N {
  static getYurtzeitenDesign_N = async (
    getYurtzeitenDesign_N: GetYurtzeitenDesign_N
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_YURTZEITEN_DESIGN_N_URL, {
      params: getYurtzeitenDesign_N,
    });
    return response;
  };

  static saveYurtzeitenDesign_N = async (
    saveYurtzeitenDesign_N: SaveYurtzeitenDesign_N
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      SAVE_YURTZEITEN_DESIGN_N_URL,
      {
        ...saveYurtzeitenDesign_N,
      }
    );
    return response;
  };

  // Uploaded on its own, ahead of the design being saved, so the stored HTML
  // only ever carries a URL rather than an inlined file.
  static uploadYurtzeitenDesignImage_N = async (
    formData: FormData
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      UPLOAD_YURTZEITEN_DESIGN_IMAGE_N_URL,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response;
  };
}

export default YurtzeitenDesign_N;
